import { isNil, negate } from "lodash";

export const isNotNil = negate(isNil);
